const ResumeApi = [
  {
    id: 1,
    category: "education",
    year: "culture and science city (2021 - 2025)",
    title: "BACHELOR OF COMPUTER SCIENCE",
    desc: "I study computer science, I Study Programming, Algorithms and Data Structures, Computer Architecture, Operating Systems, Database Systems, Artificial Intelligence and Machine Learning, And another...",
    rate: "4.30/5",
  },
  {
    id: 4,
    category: "experience",
    year: "Scale Up Company | 2023 - Present",
    title: "FRONTEND DEVELOPER",
    desc: "I learned No-code development platforms such (WordPress, webflow), Worked on a variety of projects ranging from small websites to large-scale web applications, Developed user-friendly and visually appealing user interfaces with a strong focus on responsive design principles and techniques.",
    rate: "4.70/5 ",
  },
  {
    id: 5,
    category: "experience",
    year: "Freelancer | 2022 - 2023",
    title: "FRONTEND DEVELOPER",
    desc: "Practice and gain experience in creating many real projects, Acquire project management skill",
    rate: "4.95/5 ",
  },
  {
    id: 6,
    category: "experience",
    year: "MYM Company | 2022 - 2023",
    title: "FrontEnd Developer Intern",
    desc: "I gained valuable practical experience, working on real-world projects, collaborating with experienced professionals, and gaining practical knowledge of industry-standard tools, techniques, and best practices. During my internship, I enhanced my front-end development skills. Learned frameworks (such as Next.JS) and other relevant tools and libraries. This experience allowed me to deepen my understanding of front-end development concepts and become more proficient in building user interfaces",
    rate: "5.00/5 ",
  },
  {
    id: 7,
    category: "experience",
    year: "self study | 2021 - 2022",
    title: "FrontEnd Developer",
    desc: "Practice and create many projects. Problem-solving and critical thinking",
    rate: "5.00/5 ",
  },
];

export default ResumeApi;
